// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/content-documents/media-document/media-type-icon/media-type-icon.component.scss
// module id = 159
// module chunks = 0